import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const categoryApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/categories/`, {params: params})
  },
  detail (episodeId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/categories/${episodeId}/`, {params: params})
  }
}

export default categoryApi
